import { render } from "./CategorySelection.vue?vue&type=template&id=fc0b907e&ts=true"
import script from "./CategorySelection.vue?vue&type=script&lang=ts"
export * from "./CategorySelection.vue?vue&type=script&lang=ts"

import "./CategorySelection.vue?vue&type=style&index=0&id=fc0b907e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__